import { generateClient } from 'aws-amplify/api';
import { searchGroups } from "../common/graphql/queries";
import FormSelectInput from "./FormSelectInput";

const client = generateClient();

let runningPromise = {};
const FormSelectGroup = ({ locationId, includeDivisions = false, onlyDivisions = false, ...props }) => {
    const loadOptions = async (input) => {
        try {
            if (runningPromise[props.name]) client.cancel(runningPromise[props.name], "cancelled");
            let filter = {
                locationId: { eq: locationId },
                name: { wildcard: `*${input}*` },
            }

            if (!includeDivisions) filter.division = { eq: includeDivisions }
            if (onlyDivisions) filter.division = { eq: true }
            runningPromise[props.name] = client.graphql({
                query: searchGroups,
                variables: {
                    filter,
                    sort: { direction: "asc", field: "name" },
                    limit: 99,
                },
            })

            const { data: { searchGroups: { items } } } = await runningPromise[props.name];

            return items.map(cx => ({ value: cx.id, label: cx.name }))
        } catch (ex) {
            return [];
        }
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} />
    )
}

export default FormSelectGroup;